import React from 'react';
import { Link } from 'react-router-dom';
import './WhoWeAre.css';

function WhoWeAre() {
  return (
    <div className="who-we-are">
      <div className="who-we-are-text-container">
        <div className="who-we-are-title">Who We Are</div>
        <div className="who-we-are-description">
          DJ's Dog Park Bar is a place where dog lovers and their furry friends come together to create lifelong memories. 
          Founded by passionate pet owners, we provide a welcoming environment that combines the love of dogs, a sense of community, 
          and a space for everyone to enjoy.
          <br /><br />
          <Link to="/About-Us">
            <button className="who-we-are-button">More About Us</button>
          </Link>
        </div>
      </div>
      <div className="who-we-are-image">
        <img src="https://res.cloudinary.com/dboapnol9/image/upload/v1779151914/oppa_pissing_test_kd4eql.jpg" alt="A tan and white dog by the picket fence at DJ's Dog Bar" />
      </div>
    </div>
  );
}

export default WhoWeAre;
